/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ManageUserProfile } from '../../models/manage-user-profile';

export interface ApiAccountMeprofileGet$Params {
}

export function apiAccountMeprofileGet(http: HttpClient, rootUrl: string, params?: ApiAccountMeprofileGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ManageUserProfile>> {
  const rb = new RequestBuilder(rootUrl, apiAccountMeprofileGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ManageUserProfile>;
    })
  );
}

apiAccountMeprofileGet.PATH = '/api/account/meprofile';
